var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "retail-shell" }, [_c("cashier-desk")], 1)
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }